import { useEffect, useState } from "react";
import { proprietariosService } from "../services/proprietariosService";

export const useProprietarios = (usuarioId: number | null, fetch: boolean) => {
  const [usuario, setUsuario] = useState<any | null>(null);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    const fetchUsuarios = async () => {
      if (usuarioId && fetch) {
        setLoading(true);
        try {
          const data = await proprietariosService(usuarioId);
          if (data) {
            setUsuario(data); // Define o objeto retornado se for válido
          } else {
            setUsuario(null); // Define como null se data não for válido
          }
        } catch (err) {
          console.error("Erro ao buscar proprietário:", err);
          setUsuario(null); // Define como null em caso de erro
        } finally {
          setLoading(false);
        }
      } else {
        setUsuario(null);
        setLoading(false);
      }
    };

    fetchUsuarios();
  }, [usuarioId, fetch]);

  return { usuario, loading };
};
